import { type CellContext } from '@tanstack/react-table';

interface CellIndexProps<TData, TValue> extends CellContext<TData, TValue> {}

export function CellIndex<TData, TValue>({ row, table, getValue }: CellIndexProps<TData, TValue>) {
    const { pageIndex, pageSize } = table.getState().pagination;
    const rowIndex = row.index + 1 + pageIndex * pageSize;

    const value = getValue();
    return <span className="font-mono text-gray-400">{value ? value.toString() : rowIndex}</span>;
}
